<template>
    <div class="playSet" v-if='form'>
        <!--上面部分-->
        <div class="setTop padding-20 bgc box-shadow">
            <img :src="form.logourl" alt="">
            <div class="rightText">
                <p class="title">{{form.subject}}</p>
                <p>直播简介：{{form.description}}</p>
                <p>直播时间：{{form.begintime}}</p>
                <p :class="form.feetype==2?'nofeetype':'feetype'">{{form.feetype==1?'免费':(form.feetype==3?'加密':'￥'+form.saleprice)}}</p>
                <div class="topBtn">
                    <el-button type="primary" @click="handleGoLive" :disabled="isEnd">去直播</el-button>
                    <el-button type="primary" plain @click="handleAnchorSet">主播设置</el-button>
                    <el-button type="primary" plain @click="handleEdit">直播编辑</el-button>
                    <el-button type="primary" plain @click="shareEvent">分享</el-button>
                </div>
            </div>
        </div>
        <!--下面部分-->
        <div class="setBottom padding-20 bgc box-shadow" v-if="playData">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="关联活动设置" name="first"><ActiveSet ref="activeSet"></ActiveSet></el-tab-pane>
                <el-tab-pane label="暖场设置" name="second" v-if="screenmode==1"><WarmSet ref="warmSet"></WarmSet></el-tab-pane>
                <el-tab-pane label="互动设置" name="third"><InteractionSet ref="interactionSet"></InteractionSet></el-tab-pane>
                <el-tab-pane label="防盗设置" name="fourth"><TheftSet ref="theftSet"></TheftSet></el-tab-pane>
                <el-tab-pane label="数据分析" name="five"><DataAnalysis ref="dataAnalysis" v-if="activeName=='five'"></DataAnalysis></el-tab-pane>
            </el-tabs>
        </div>
        <LiveTools ref="liveTools"></LiveTools>
        <AnchorSet ref="anchorSet"></AnchorSet>
        <brandShareDialog ref="brandShareDialog"></brandShareDialog>
    </div>
</template>

<script>
    import {getVliveEventBriefInfo,getLiveEventPlaySettingInfo} from 'api/vliveV2Api'
    import {mapGetters, mapActions} from 'vuex'
    import LiveTools from '@/views/vliveV2/components/liveTools'
    import AnchorSet from '@/views/vliveV2/components/anchorSet'
    import ActiveSet from '@/views/vliveV2/components/activeSet'
    import WarmSet from '@/views/vliveV2/components/warmSet'
    import InteractionSet from '@/views/vliveV2/components/interactionSet'
    import TheftSet from '@/views/vliveV2/components/theftSet'
    import DataAnalysis from '@/views/vliveV2/components/dataAnalysis'
    import BrandShareDialog from 'views/brandBusiness/components/brandShareDialog.vue'
    export default {
        name: "PlaySet",
        data(){
            return{
                activeName: 'first',
                liveid:this.$route.query.liveid ? this.$route.query.liveid : '', // 直播id
                form:null,
                playData:null,
                ready: false,
                shareurl:'',
                isEnd:false,
                screenmode:'', //1横屏 2竖屏
            }
        },
        mounted() {
            this.getInfo();
            this._getPlayInfo()
        },
        methods:{
            //获取直播活动
            getInfo(){
                this.setLoading(true);
                let param={
                    liveid:this.liveid
                };
                getVliveEventBriefInfo({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.form=data.data;
                        sessionStorage.setItem('liveInfo', JSON.stringify(data.data));
                        this.setLiveInfo(data.data);
                        this.ready = true
                        this.shareurl=data.data.shareurl
                        this.screenmode=data.data.screenmode
                        this.isEnd=[10,100].indexOf(data.data.status)>=0
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            //获取播放设置信息
            _getPlayInfo(){
                this.setLoading(true);
                let param={
                    liveid:this.liveid
                };
                getLiveEventPlaySettingInfo({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.playData = data.data;
                        // console.log(this.playData)
                        sessionStorage.setItem('playInfo', JSON.stringify(data.data));
                        this.setPlayInfo(data.data);
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            //去直播
            handleGoLive(){
                this.$refs.liveTools.open(this.form.liveid);
            },
            //主播设置
            handleAnchorSet(){
                this.$refs.anchorSet.open(this.form.liveid,this.form.status);
            },
            //直播编辑
            handleEdit(){
                this.$router.push({name: 'LiveEdit',query:{liveid:this.form.liveid}})
            },
            //分享
            shareEvent(){
                this.$refs.brandShareDialog.openDialog(this.shareurl,'分享直播')
            },
            handleClick(tab, event) {
                // console.log(tab, event);
            },
            ...mapActions([
                'setLoading','setLiveInfo','setPlayInfo'
            ])
        },
        computed: {
            ...mapGetters([
                'loading','liveInfo','playInfo'
            ])
        },
        components: {
            LiveTools,AnchorSet,ActiveSet,WarmSet,InteractionSet,TheftSet,DataAnalysis,BrandShareDialog
        }
    }
</script>

<style lang="scss">
    .playSet{
        height: 100%;
        .setTop{
            display: flex;
            align-items: flex-start;
            img{
                width:280px;
                min-width: 280px;
                height:160px;
                margin-right: 20px;
                background: #eee;
                display: inline-block;
            }
            .rightText{
                p{
                    margin-bottom: 10px;
                    color: #999;
                    font-size: 14px;
                    line-height: 20px;
                }
                .title{
                    font-size: 16px;
                    color: #333;
                }
                .feetype{
                    color: #409EFF;
                }
                .nofeetype{
                    color: #F56C6C;
                }
                .topBtn{
                    margin-top: 18px;
                }
            }
        }
        .setBottom{
            margin-top: 20px;
            /*height: 100%;*/
            .el-tabs__nav-wrap::after{
                height: 1px;
            }
        }
    }
</style>
